import { format, parseISO } from "date-fns";
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa6";
import { BsBuilding } from "react-icons/bs"; // Company
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FiRefreshCw } from "react-icons/fi";
import localforage from "localforage";
import { MdOutlineNoteAdd } from "react-icons/md";
import {
  FaRupeeSign,
  FaArrowUp,
  FaArrowDown,
  FaChartLine,
  FaChartBar,
  FaProjectDiagram,
} from "react-icons/fa";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  ComposedChart,
} from "recharts";
import { MdBarChart, MdShowChart } from "react-icons/md";

const GlobalStock = () => {
  const { ticker } = useParams();
  const [stock, setStock] = useState();
  const [detail, setDetail] = useState();
  const [rsi, setRsi] = useState();
  const [macd, setMacd] = useState();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  //   useEffect(() => {
  //     const fetchStock = async () => {
  //       const response = await axios.get(
  //         "http://localhost:8000/api/stockoverview",
  //         {
  //           params: { symbol: ticker },
  //         }
  //       );
  //       console.log("Response", response.data);
  //       setStock(response.data);
  //     };
  //     const fetchStockData = async () => {
  //       const response = await axios.get(
  //         "http://localhost:8000/api/stockdailydata",
  //         {
  //           params: { symbol: ticker },
  //         }
  //       );
  //       console.log("Response", response.data);
  //       setDetail(response.data);
  //     };
  //     fetchStock();
  //     fetchStockData();
  //   }, [ticker]);
  const CACHE_TTL = 60 * 60 * 1000; // 1 hour
  const cacheKey = `stock_${ticker.toUpperCase()}_cache`;

  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };

  // const handleRefresh = async (forceRefresh = false) => {
  //   if (!ticker) return;

  //   try {
  //     setLoading(true);
  //     setError(null);

  //     // 🧩 1️⃣ Try cached data (if not forced)
  //     const cached = JSON.parse(localStorage.getItem(cacheKey));
  //     const isValid =
  //       cached && Date.now() - cached.timestamp < CACHE_TTL && cached.data;

  //     if (isValid && !forceRefresh) {
  //       console.log(`✅ Using cached data for ${ticker}`);
  //       setStock(cached.data.overview);
  //       setDetail(cached.data.daily);
  //       setRsi(cached.data.rsi);
  //       setMacd(cached.data.macd);
  //       setLoading(false);
  //       return;
  //     }

  //     console.log(`🆕 Fetching new data for ${ticker}...`);

  //     // 🧩 2️⃣ Fetch fresh data
  //     const [overviewRes, dailyRes, rsiRes, macdRes] = await Promise.all([
  //       // axios.get("http://localhost:8000/api/stockoverview", {
  //       axios.get(`${BASE_URL}/api/stockoverview`, {
  //         params: { symbol: ticker },
  //       }),
  //       axios.get(`${BASE_URL}/api/stockdailydata`, {
  //         params: { symbol: ticker },
  //       }),
  //       axios.get(`${BASE_URL}/api/stockRsi`, {
  //         params: { symbol: ticker },
  //       }),
  //       axios.get(`${BASE_URL}/api/stockMacd`, {
  //         params: { symbol: ticker },
  //       }),
  //     ]);

  //     const newData = {
  //       overview: overviewRes.data,
  //       daily: dailyRes.data,
  //       rsi: rsiRes.data,
  //       macd: macdRes.data,
  //     };

  //     // 🧩 3️⃣ Update state
  //     setStock(newData.overview);
  //     setDetail(newData.daily);
  //     setRsi(newData.rsi);
  //     setMacd(newData.macd);

  //     await localforage.setItem(cacheKey, {
  //       timestamp: Date.now(),
  //       data: newData,
  //     });

  //     console.log(`💾 Cached fresh data for ${ticker}`);
  //   } catch (err) {
  //     console.error(`❌ Error fetching data for ${ticker}:`, err.message);
  //     setError("Api Failed!");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleRefresh = useCallback(
    async (forceRefresh = false) => {
      if (!ticker) return;

      const cacheKey = `stock_${ticker.toUpperCase()}_cache`;

      try {
        setLoading(true);
        setError(null);

        // 🧩 1️⃣ Try cached data (if not forced)
        const cached = await localforage.getItem(cacheKey); // ✅ Corrected
        const isValid =
          cached && Date.now() - cached.timestamp < CACHE_TTL && cached.data;

        if (isValid && !forceRefresh) {
          console.log(`✅ Using cached data for ${ticker}`);

          setStock(cached.data.overview);
          setDetail(cached.data.daily);
          setRsi(cached.data.rsi);
          setMacd(cached.data.macd);
          setLastUpdated(formatTimestamp());
          setLoading(false);
          return;
        }

        console.log(`🆕 Fetching new data for ${ticker}...`);

        // 🧩 2️⃣ Fetch fresh data (Parallel requests)
        const [overviewRes, dailyRes, rsiRes, macdRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/stockoverview`, {
            params: { symbol: ticker },
          }),

          axios.get(`${BASE_URL}/api/stockdailydata`, {
            params: { symbol: ticker },
          }),
          axios.get(`${BASE_URL}/api/stockRsi`, { params: { symbol: ticker } }),
          axios.get(`${BASE_URL}/api/stockMacd`, {
            params: { symbol: ticker },
          }),
        ]);

        const newData = {
          overview: overviewRes.data,
          daily: dailyRes.data,
          rsi: rsiRes.data,
          macd: macdRes.data,
        };

        // 🧩 3️⃣ Update State
        setStock(newData.overview);
        setDetail(newData.daily);
        setRsi(newData.rsi);
        setMacd(newData.macd);

        // 🧩 4️⃣ Cache it properly
        await localforage.setItem(cacheKey, {
          timestamp: Date.now(),
          data: newData,
        });

        console.log(`💾 Cached fresh data for ${ticker}`);
        setLastUpdated(formatTimestamp());
      } catch (err) {
        console.error(`❌ Error fetching data for ${ticker}:`, err.message);
        setError("API Failed!");
      } finally {
        setLoading(false);
      }
    },
    [ticker], // ✅ memoized function so ESLint won’t complain
  );
  console.log("Response", stock);
  console.log("Detail", detail);
  console.log("Rsi", rsi);
  console.log("Macd", macd);
  const rsiData = rsi?.["Technical Analysis: RSI"];
  const macdData = macd?.["Technical Analysis: MACD"];
  const dates = rsiData && Object.keys(rsiData);

  const macdDates = macdData && Object.keys(macdData);

  macdDates?.sort((a, b) => new Date(a) - new Date(b));
  // Sort them chronologically (latest date last)
  dates?.sort((a, b) => new Date(a) - new Date(b));

  // Get the latest date
  const latestDate = dates?.[dates.length - 1];
  const lastestMacdDate = macdDates?.[macdDates.length - 1];
  console.log("Latest date", latestDate);
  console.log("Lastets Macd date", lastestMacdDate);

  // Get its RSI value
  const latestRSI = parseFloat(rsiData?.[latestDate]?.RSI || 0);
  const latestMacd = parseFloat(macdData?.[lastestMacdDate]?.MACD || 0);
  console.log("LatestRsi", latestRSI);
  console.log("latest MACD", latestMacd);
  // suppose macdData is the object you showed
  const macdChartData = macd
    ? Object.entries(macdData)
        .map(([date, values]) => ({
          date,
          MACD: parseFloat(values.MACD),
          signal: parseFloat(values.MACD_Signal),
          histogram: parseFloat(values.MACD_Hist),
        }))
        .sort((a, b) => new Date(a.date) - new Date(b.date))
    : [];
  const macdYears = macdChartData.length
    ? [
        ...new Set(
          macdChartData.map((item) => new Date(item.date).getFullYear()),
        ),
      ]
    : [];
  console.log("Macd years", macdYears);

  const rsiArray = rsiData
    ? Object.entries(rsiData)
        .filter(([date, values]) => values && values.RSI)
        .map(([date, values]) => ({
          date,
          RSI: parseFloat(values.RSI),
        }))
        .sort((a, b) => new Date(a.date) - new Date(b.date))
    : [];
  console.log("Rsi Array", rsiArray);
  const rsiYears = rsiArray.length && [
    ...new Set(rsiArray.map((item) => new Date(item.date).getFullYear())),
  ];
  console.log("Rsiyears", rsiYears);
  //filtredmacd
  // const filteredMacdData = selectedYear
  //   ? macdChartData.filter((item) => item.date.startsWith(selectedYear))
  //   : macdChartData;

  const filteredMacdData = selectedYear
    ? macdChartData.filter((item) => item.date.startsWith(selectedYear))
    : macdChartData;
  console.log("FILTEREDMACD", filteredMacdData);
  console.log("macdchartdata", macdChartData);
  const indicators = {
    macd: macdChartData,
    rsi: rsiArray.map((item) => item.RSI), // only numeric RSI values
  };
  console.log("Indicators", indicators);
  const getInterpretation = (indicators) => {
    // --- SAFETY CHECK ---
    if (
      !indicators ||
      !Array.isArray(indicators.macd) ||
      !Array.isArray(indicators.rsi) ||
      indicators.macd.length === 0 ||
      indicators.rsi.length === 0
    ) {
      return {
        result: " Insufficient data",
        color: "#fbbf24",
        prediction: "Neutral",
      }; // gray
    }

    // --- GET LATEST VALUES ---
    const latestMACD = indicators.macd.slice(-1)[0];
    const latestRSI = indicators.rsi.slice(-1)[0];

    // --- DETERMINE RSI STATUS ---
    let rsiStatus = "Neutral";
    if (latestRSI >= 70) rsiStatus = "Overbought";
    else if (latestRSI <= 30) rsiStatus = "Oversold";
    else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
    else rsiStatus = "Neutral-Bearish";

    // --- DETERMINE MACD STATUS ---
    let macdStatus = "Neutral";
    if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
      macdStatus = "Bullish";
    } else if (
      latestMACD.MACD < latestMACD.signal &&
      latestMACD.histogram < 0
    ) {
      macdStatus = "Bearish";
    }

    // --- COMBINED INTERPRETATION ---
    // RSI + MACD agree strongly → high-confidence momentum
    if (
      (rsiStatus.includes("Bullish") || latestRSI > 55) &&
      macdStatus === "Bullish"
    ) {
      return {
        result: " Strong Bullish Momentum (RSI & MACD aligned)",
        color: "#249966",
        prediction: "Buy", // green
      };
    }

    if (
      (rsiStatus.includes("Bearish") || latestRSI < 45) &&
      macdStatus === "Bearish"
    ) {
      return {
        result: " Strong Bearish Momentum (RSI & MACD aligned)",
        color: "#f87171",
        prediction: "Sell", // red
      };
    }

    // --- DIVERGENCE CASES ---
    // RSI uptrend but MACD downtrend or vice versa
    if (
      (latestRSI > 50 &&
        latestMACD.MACD < latestMACD.signal &&
        latestMACD.histogram < 0) ||
      (latestRSI < 50 &&
        latestMACD.MACD > latestMACD.signal &&
        latestMACD.histogram > 0)
    ) {
      return {
        result:
          " Divergence detected (RSI and MACD conflict) - Possible reversal ahead",
        color: "#fbbf24", // yellow
      };
    }

    // --- EXTREME CONDITIONS ---
    if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
      return {
        result: " Overbought! Bullish but nearing exhaustion",
        color: "#f59e0b",
        prediction: "Buy", // amber-orange
      };
    }

    if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
      return {
        result: " Oversold! Bearish but near potential rebound zone",
        color: "#60a5fa",
        prediction: "Sell", // blue
      };
    }

    // --- NEUTRAL / SIDEWAYS ---
    return {
      result: "Neutral / Sideways Market (No strong signal)",
      color: "#9ca3af",
      prediction: "Neutral", // grayish neutral
    };
  };

  const { result, color, prediction } = getInterpretation(indicators);
  console.log("Result", result);
  //   const timeDetail = detail["Time Series (Daily)"];
  //   console.log("TimeDetail", timeDetail);
  //   const latestDate = Object.keys(timeDetail).sort(
  //     (a, b) => new Date(b) - new Date(a)
  //   )[0];

  //   const latestData = timeDetail[latestDate];
  //   console.log("detail", latestData);
  useEffect(() => {
    handleRefresh();
  }, [handleRefresh]);

  let latestStockData = null;

  const timeSeries = detail?.["Time Series (Daily)"];

  if (timeSeries && typeof timeSeries === "object") {
    const dates = Object.keys(timeSeries).sort(
      (a, b) => new Date(b) - new Date(a),
    );
    const latestDate = dates[0];
    latestStockData = { date: latestDate, ...timeSeries[latestDate] };
  }

  let percentChange = null;
  if (timeSeries) {
    const dates = Object.keys(timeSeries).sort(
      (a, b) => new Date(b) - new Date(a),
    );

    const latestDate = dates[0];
    const prevDate = dates[1];

    const latestClose = parseFloat(timeSeries[latestDate]["4. close"]);
    const prevClose = parseFloat(timeSeries[prevDate]["4. close"]);

    percentChange = (((latestClose - prevClose) / prevClose) * 100).toFixed(2);
  }
  console.log("Percent Change", percentChange);

  console.log("Latest Stock Data:", latestStockData);

  const companyName = stock?.Name;
  console.log("companyName", companyName);
  const symbolCode = stock?.Symbol;
  console.log("Symbol", symbolCode);
  const peRatio = stock?.PERatio;
  console.log("PE Ratio", peRatio);
  const bookValue = stock?.BookValue;
  console.log("bookValye", bookValue);
  const low = latestStockData?.["3. low"];
  console.log("Low", low);
  const high = latestStockData?.["2. high"];
  console.log("High", high);
  const open = latestStockData?.["1. open"];
  console.log("Open", open);
  const close = latestStockData?.["4. close"];
  console.log("Close", close);
  const volume = latestStockData?.["5. volume"];
  const handleManualRefresh = async () => {
    await handleRefresh(true);
  };
  // const formatVolume = (volume) => {
  //   return typeof volume === "string"
  //     ? Number(volume).toLocaleString()
  //     : volume.toLocaleString();
  // };
  const formatVolume = (volume) => {
    if (volume == null) return "-";

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };
  const hasData = stock || detail || rsi || macd;

  // const macdYears = macdChartData.length
  // ? [...new Set(macdChartData.map(item => new Date(item.date).getFullYear()))]
  // : [];

  // Auto-select latest year on load
  useEffect(() => {
    if (macdYears.length > 0 && !selectedYear) {
      const latestYear = Math.max(...macdYears);
      setSelectedYear(String(latestYear));
    }
  }, [macdYears]);

  // Filter for selected year

  return (
    <>
      <div>
        <div className="last-updated-head">
          {lastUpdated && <span>As on {lastUpdated}</span>}
          <FiRefreshCw
            onClick={handleManualRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>

        {loading ? (
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "700",

              display: "flex",
              gap: "1rem",
            }}
          >
            Fetching Live data..
            <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
              <FaSpinner />
            </span>
          </p>
        ) : error && !hasData ? (
          <div>
            <p
              style={{
                fontSize: "1rem",
                fontWeight: "700",
                color: "white",
                display: "flex",
                gap: "1rem",
              }}
            >
              Failed to load data, please refresh again..
            </p>
          </div>
        ) : (
          <>
            <div className="stock-detail-card">
              <div className="analysis-container">
                <div className="analysis-header">
                  <div className="analysis-head-name">
                    <h2 className="stock-title">{companyName}</h2>
                    <span className="stock-tag">{symbolCode}</span>
                  </div>

                  <div className="action-buttons">
                    <button className="btn-buy">Buy</button>
                    <button className="btn-sell">Sell</button>
                    <button className="btn-hold">Hold</button>
                    <button className="btn-star">★</button>
                  </div>
                </div>

                <div className="price-summary">
                  <div>
                    <p className="label">% Change</p>
                    <h3
                      className="value positive"
                      style={{
                        color: percentChange > 0 ? "#2fd18a" : "#f87171",
                      }}
                    >
                      + {percentChange}%
                    </h3>
                  </div>
                  <div>
                    <p className="label">Open</p>
                    <h3 className="value">{open}</h3>
                  </div>
                  <div>
                    <p className="label">Close</p>
                    <h3 className="value">{close}</h3>
                  </div>
                  <div>
                    <p className="label">Low</p>
                    <h3 className="value">{low}</h3>
                  </div>
                  <div>
                    <p className="label">High</p>
                    <h3 className="value">{high}</h3>
                  </div>
                </div>

                <div className="factor-wrapper">
                  <div className="factor-box">
                    <h4>Technical Factors</h4>
                    <div className="inner-factor-box">
                      <div className="factor-row">
                        <p>RSI</p>
                        <span
                          style={{
                            color: latestRSI > 0 ? "#2fd18a" : "#f87171",
                          }}
                        >
                          {" "}
                          {latestRSI?.toFixed(2)}
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>MACD</p>
                        <span className="positive">
                          {latestMacd?.toFixed(2)}
                        </span>
                      </div>
                      <div className="factor-row">
                        <p>Volume</p>
                        <span>{formatVolume(volume)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="insight-box"
                  style={{
                    borderLeft: `4px solid ${color}`,
                  }}
                >
                  <p className="insight-head">Phro Trader Insights</p>
                  <div className="sub-insight">
                    <div
                      className="insight-text"
                      style={{
                        color: color,
                      }}
                    >
                      {result}
                    </div>
                    <button
                      className="insight-tag"
                      style={{ backgroundColor: color, color: "white" }}
                    >
                      {prediction}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {filteredMacdData && filteredMacdData.length > 0 && (
              <div className="macd-chart-graph" style={{ marginTop: 30 }}>
                <div className="chart-top-heading">
                  <h3
                  // style={{
                  //   color: "#fff",
                  //   fontWeight: "bold",
                  //   fontSize: "1.5rem",
                  //   marginLeft: "1.5rem",
                  // }}
                  >
                    📊 MACD Line, Signal & Histogram
                  </h3>
                  <div style={{ marginBottom: "10px", textAlign: "right" }}>
                    <select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                      style={{
                        padding: "6px 10px",
                        background: "inherit",

                        borderRadius: "6px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                        fontWeight: "600",
                      }}
                    >
                      <option value="">Select Year</option>
                      {macdYears.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                  {/* <ComposedChart data={macdChartData}> */}
                  <ComposedChart data={filteredMacdData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                    <XAxis
                      dataKey="date"
                      tickFormatter={(date, index) => {
                        if (!date || typeof date !== "string") return "";
                        try {
                          const hasTime = date.includes(":");
                          const d = new Date(date.replace(" ", "T"));
                          if (hasTime) {
                            return index % 15 === 0
                              ? d.toLocaleTimeString("en-IN", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })
                              : "";
                          }
                          return index % 10 === 0
                            ? d.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                              })
                            : "";
                        } catch {
                          return "";
                        }
                      }}
                      tick={{ fill: "#fff", fontWeight: "bold", fontSize: 10 }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    />
                    <YAxis
                      tick={{ fill: "#fff", fontWeight: "bold", fontSize: 10 }}
                      axisLine={{ stroke: "#fff" }}
                      tickLine={{ stroke: "#fff" }}
                    />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#1f2937",
                        border: "none",
                        color: "#fff",
                      }}
                      labelFormatter={(label) => {
                        try {
                          if (!label) return "";
                          const hasTime = label.includes(":");
                          const d = new Date(label.replace(" ", "T"));
                          if (isNaN(d.getTime())) return label;
                          if (hasTime) {
                            return d.toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            });
                          }
                          return d.toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });
                        } catch {
                          return label;
                        }
                      }}
                      labelStyle={{ color: "#fff", fontWeight: "bold" }}
                      itemStyle={{ color: "#fff" }}
                    />
                    <Legend
                      wrapperStyle={{ fontWeight: "bold" }}
                      payload={[
                        {
                          value: "Histogram (Bullish)",
                          type: "square",
                          color: "#2fd18a",
                        },
                        {
                          value: "Histogram (Bearish)",
                          type: "square",
                          color: "#f87171",
                        },
                        { value: "MACD", type: "line", color: "#2563eb" },
                        { value: "Signal", type: "line", color: "#f59e0b" },
                      ]}
                    />
                    <Bar
                      dataKey="histogram"
                      barSize={20}
                      shape={(props) => {
                        const { x, y, width, height, value } = props;
                        return (
                          <rect
                            x={x}
                            y={value >= 0 ? y : y - height}
                            width={width}
                            height={Math.abs(height)}
                            fill={value >= 0 ? "#2fd18a" : "#f87171"}
                          />
                        );
                      }}
                    />
                    <Line
                      type="monotone"
                      dataKey="MACD"
                      stroke="#2563eb"
                      strokeWidth={2}
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="signal"
                      stroke="#f59e0b"
                      strokeWidth={2}
                      dot={false}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default GlobalStock;
